import _ from 'lodash';
import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'drp-input',
  templateUrl: 'drp.input.html'
})
export class DrpInputComponent implements OnChanges {
  @Input() defaultValue;
  @Input() options;
  @Input() label;
  @Input() disabled:boolean = false;

	@Output() onSelect:EventEmitter<string> = new EventEmitter();

  showOptions: boolean = false;
  selectedLabel = null;
  defaultText: string = '선택';

  ngOnChanges() {
    if(this.defaultValue != null && this.options != null) {
      let selected = _.find(this.options, { value: this.defaultValue });
      if(selected != null) {
        this.selectedLabel = selected.label;
      } 
    }
  }

  hideOptions() {
    this.showOptions = false;
  }

  handleShowOptions() {
    if(this.disabled){
      return;
    }
    if(this.showOptions) {
      this.showOptions = false;
    } else {
      this.showOptions = true;
    }
  }

  handleSelectValue(option) {
    this.selectedLabel = option.label;
    this.onSelect.emit(option);
    this.showOptions = false;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/inputs/drp.input.ts